import { put } from 'redux-saga/effects';
import { actions as actionsUi } from 'ducks/ui';

export default function* authenticatorConfSetter({ payload: { data } }) {
  try {
    if (data?.authenticatorConf) {
      yield put(actionsUi.setConf(data?.authenticatorConf));
    }
  } catch (err) {
    // eslint-disable-next-line
    console.log('error', err);
  }
}
